module.exports = __webpack_public_path__ + "img/7_148.12a70e41.png";